import React, { forwardRef } from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import SubmitButton from "./SubmitButton";
import { Button } from "@progress/kendo-react-buttons";

const CustomTitleBar = (title) => {
  return (
    <div
      style={{
        fontSize: "16px",
        lineHeight: "1.3em",
        width: "250px",
        color: "red",
        display: "flex",
        alignItems: "center",
      }}
    >
      <span className="k-icon k-i-warning" style={{ marginRight: "5px" }} />
      Confirmation Dialog
    </div>
  );
};

const ConfirmationDialog = forwardRef(
  (
    { title = "Please confirm", onClose, onClickYes, onClickNo, content, isLoading = false },
    ref
  ) => {
    return (
      <Dialog
        ref={ref}
        id="action_dialog"
        // height={180}
        title={<CustomTitleBar />}
        width={600}
        onClose={onClose}
      >
        <div className="w-100">
          <p
            style={{
              margin: "25px",
              textAlign: "center",
            }}
          >
            {content ? content : "Are you sure to remove file?"}
          </p>
          <div className="mt-2 d-flex align-center justify-content-center me-4 mb-3">
            <Button
              className="common-btn me-2 bgBtnSecondary"
              onClick={onClickNo}
              disabled={isLoading}
            >
              No
            </Button>
            <SubmitButton
              onClick={onClickYes}
              className="me-4"
              isLoading={isLoading}
            >
              Yes
            </SubmitButton>
          </div>
        </div>
      </Dialog>
    );
  }
);

export default ConfirmationDialog;
